import { List, Datagrid, TextField } from "react-admin";

import useDataGridStyles from "../components/DataGridStyle";
import LayoutContainer from "../components/LayoutContainer";
import exporter from "../../../utils/exporter";
import SfBreadcrumbs from "../../../components/SfBreadcrumbs";
import CustomAction from "../components/CustomAction";
import CustomDateField from "../components/CustomDateField";
// const useStyles = makeStyles((theme) => ({
//   container: {
//     position: "absolute",
//     top: 0,
//     bottom: 0,
//     left: 0,
//     right: 0,
//     overflow: "auto",
//   },
// }));

const UserList = (props) => {
  const title = "Roles";
  const headers = [
    { label: "Name", source: "name" },
    { label: "Description", source: "desc" },
    { label: "Status", source: "status" },
    { label: "Created", source: "time" },
  ];
  const classes = useDataGridStyles();
  return (
    <LayoutContainer>
      <SfBreadcrumbs path="Management/Roles" lower />
      <List
        {...props}
        //filters={<ProductFilter />}
        perPage={10}
        bulkActionButtons={false}
        exporter={(data) => exporter(data, headers, title)}
        actions={<CustomAction labelCreate="Add Roles" />}
        classes={{ content: classes.content }}
      >
        <Datagrid
          rowClick="show"
          classes={{ headerCell: classes.header, rowCell: classes.row }}
        >
          <TextField label="Name" source="name" />
          <TextField label="Description" source="desc" />
          <TextField label="Status" source="status" />
          <CustomDateField label="Date" source="time" />
        </Datagrid>
      </List>
      {/* <PermissionChecker code="Page.Merchant.Management.User" /> */}
    </LayoutContainer>
  );
};
/**
 * <ReferenceManyField
          label="Amount"
          target="product_id"
          reference="stock"
        >
          <SingleFieldList>
            <ChipField source="remaining" />
          </SingleFieldList>
        </ReferenceManyField>
 */
export default UserList;
